module.exports = "mutation setToClosed($closeInput:CloseInput!,$unassign:Boolean){setToClosed(closeInput:$closeInput,unassign:$unassign)}"